import ServiceBase from "base/baseService"

export default class TipoListaNcmService extends ServiceBase {

    title = "Tipo de lista de NCM"
    pluralTitle = "Tipos de listas de NCM"
    url = '/cadastro/fiscal/tipolistancm'
    frontUrl = '/cadastro/fiscal/tipolistancm'
    frontUrlList = '/cadastro/fiscal/tipolistancmlist'
    primaryKey = 'codigo_tilin'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        data.descricao_tilin = data?.descricao_tilin || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
